function loadBoomCartDrawerRecommendations() {
  const container = document.getElementById('BoomCartDrawerRecommendations');
  if (!container) return;
  const sectionId = container.dataset.sectionId;
  const baseUrl = container.dataset.recommendationsUrl;
  const intent = container.dataset.intent;
  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      if (!cart.items || cart.items.length === 0) {
        return null;
      }
      const firstItem = cart.items[0];
      const productId = firstItem.product_id;
      const limit = 8;
      const url = `${baseUrl}?section_id=${encodeURIComponent(
        sectionId
      )}&product_id=${encodeURIComponent(productId)}&limit=${limit}&intent=${intent}`;
      return fetch(url);
    })
    .then((res) => {
      if (!res) return null;
      return res.text();
    })
    .then((html) => {
      if (!html) return;
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const inner = temp.querySelector('#BoomCartDrawerRecommendations');
      if (inner && inner.innerHTML.trim().length > 0) {
        container.innerHTML = inner.innerHTML;
      }
    })
    .catch((e) => {
      console.error('Error loading cart drawer recommendations', e);
    });
}

function subscribeToCartUpdates() {
  const xoStore = window.xoStore || (window.xobuildercomponents && window.xobuildercomponents.xoStore);
  if (!xoStore || typeof xoStore.subscribe !== 'function') {
    setTimeout(subscribeToCartUpdates, 200);
    return;
  }

  let debounceTimer = null;
  xoStore.subscribe('xo-cart', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      loadBoomCartDrawerRecommendations();
    }, 300);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  loadBoomCartDrawerRecommendations();
  subscribeToCartUpdates();
});